<template>
  <div class="projectPage">
    <van-search
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入岗位名称"
      show-action
      shape="round"
      @input="onSearch"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="list-content" id="list-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-radio-group v-model="radio">
          <van-cell-group class="baseNone baseSalary">
            <van-cell
              :title="`${postItem.name}`"
              clickable
              v-for="postItem in itemMainList"
              :key="postItem.id"
              @click="selectitem(postItem)"
            >
              <van-radio slot="right-icon" :name="`${postItem.name}`" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closePostPicker">取消</a>
      <a href="javascript:void(0);" class="fl" @click="savePostValue">确认</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "PostList",
  data() {
    return {
      radio: "", //选中的项目
      searchName: "",
      searchKeyword: "", //搜索的姓名人员
      itemMainList: [],
      selecItemList: [],
      postData: {},
      itemId: "",
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      clientType: "", //手机类型
    };
  },
  props: {
    postIds: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.getPostList();
  },
  methods: {
    onSearch() {
      let _this = this;
      _this.searchName = _this.searchKeyword;
      _this.reloadPage();
    },
    getPostList() {
      let _this = this;
      _this.$api.baseCommon.baseMsg
        .getPostList({
          postName: _this.searchName,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.itemMainList = res.data;
            if (_this.postIds[0]) {
              _this.itemMainList.forEach((item) => {
                if (item.code == _this.postIds) {
                  _this.radio = item.name;
                }
              });
            }
            // 加载状态结束
            this.loading = false;
            _this.finished = true;
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },

    selectitem(item) {
      let _this = this;
      _this.radio = item.name;
      _this.itemId = item.code;
    },
    closePostPicker() {
      this.postData = {};
      this.$emit("setPostItems", "");
    },
    savePostValue() {
      let _this = this;
      let arrIds = [_this.itemId];
      _this.postData.id = arrIds;
      _this.postData.name = _this.radio;

      this.$emit("setPostItems", _this.postData);
      _this.postData = new Object();
    },

    reloadPage() {
      this.loading = false; //是否处于加载状态
      this.finished = false; //是否已加载完所有数据
      this.itemMainList = [];
      this.getPostList();
    },
  },
};
</script>
<style lang="less" >
.projectPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }

  .list-content {
    height: calc(100% - 45px);
    overflow-y: scroll;
    padding-bottom: 70px;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .baseSalary {
    .van-cell__title {
      span {
        display: inline-block;
        width: 85%;
        overflow: hidden;
      }
    }
  }
  .roleBtn {
    z-index: 100000;
    position: fixed;
    width: 100%;
    font-size: 0.42667rem;
    text-align: center;
    color: #333;
    height: 45px;
    border-top: 1px solid #f6f6f6;
    bottom: 0;
    z-index: 999;
    background-color: #fff;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>